import React from 'react'
import Marquee from 'react-fast-marquee'

const Screenshots = () => {
    return (
        <div className=' text-center' style={{ paddingTop: '5rem' }} id="screenshots">
            <div className='section-title mb-0'>
                <h6 className='sub-title'>SCREENSHOTS</h6>
                <h2 className='title'>
                    Modern and   <span>Beautiful</span> Interface
                </h2>
                <p className='content mb-4'>
                    Aasaann is designed with a user-friendly approach, giving you a fast and easy experience.
                </p>
            </div>
            <div className='bg-base client-border-radius p-xl-5 p-3 mt-5'>
                <div className='client-slider'>
                    <Marquee gradient={false}>
                        {new Array(11).fill(null).map((_, i) => (
                            <div className='thumb'>
                                <img src={`assets/img/screenshots/screenshots (${i + 1}).png`} alt='img' />
                            </div>
                        ))}
                    </Marquee>
                </div>
            </div>
        </div>
    )
}

export default Screenshots